import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/lib/css/mdb.min.css';
import Vue from 'vue';
import Notify from 'mdbvue/lib/components/Notify';
import App from './App.vue';
import router from './router';
import store from './store';
import Auth from './libs/Auth';

Vue.config.productionTip = false;
Vue.use(Notify);

function canaccess(page) {
    const adminpages = ['Admin', 'Adminuser', 'Admincategory', 'Preregistration']; // TODO: ajouter les autre page d'admin
    if (adminpages.includes(page) && !store.state.isadmin) {
        return false;
    }
    return true;
}

router.beforeEach((to, from, next) => {
    if (to.name !== 'Login' && to.name !== 'LostPassword' && to.name !== 'NewPassword' && to.name !== 'Register') {
        const auth = new Auth();
        auth.isLoggued().then((response) => {
            if (response) {
                if (canaccess(to.name)) {
                    if (store.state.mustcompleteprofile && to.name !== 'Profile') {
                        next({ name: 'Profile' });
                    } else {
                        next();
                    }
                } else {
                    next({ name: 'Accessdenied' });
                }
            } else {
                next({ name: 'Login' });
            }
        });
    } else {
        next();
    }
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
